/*flags*/
/*--affected*/
/*--output-format-experimentalbadge-*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "ls",
  "description": "`turbo ls` 命令的 API 参考"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "列出你的 monorepo 中的包。"
  }, {
    "heading": "",
    "content": "¥List packages in your monorepo."
  }, {
    "heading": "",
    "content": "当范围限定为整个存储库时，输出包含软件包管理器、软件包数量以及所有软件包名称和目录。"
  }, {
    "heading": "",
    "content": "¥When scoped to the entire repository, output includes package manager, package count, and all package names and directories."
  }, {
    "heading": "",
    "content": "当范围限定为一个或多个软件包时，输出包含软件包名称、目录、内部依赖和所有任务。"
  }, {
    "heading": "",
    "content": "¥When scoped to one or more packages, output includes package name, directory, internal dependencies, and all tasks."
  }, {
    "heading": "标志-flags",
    "content": "¥Flags"
  }, {
    "heading": "--affected---affected",
    "content": "自动过滤仅受当前分支更改影响的包。"
  }, {
    "heading": "--affected---affected",
    "content": "¥Automatically filter to only packages that are affected by changes on the current branch."
  }, {
    "heading": "--affected---affected",
    "content": "默认情况下，考虑的更改是 main 和 HEAD 之间的更改。"
  }, {
    "heading": "--affected---affected",
    "content": "¥By default the changes considered are those between main and HEAD."
  }, {
    "heading": "--affected---affected",
    "content": "你可以通过设置 TURBO_SCM_BASE 将 main 覆盖为默认基础包。"
  }, {
    "heading": "--affected---affected",
    "content": "¥You can override main as the default base by setting TURBO_SCM_BASE."
  }, {
    "heading": "--affected---affected",
    "content": "你可以通过设置 TURBO_SCM_HEAD 将 HEAD 覆盖为默认头包。"
  }, {
    "heading": "--affected---affected",
    "content": "¥You can override HEAD as the default head by setting TURBO_SCM_HEAD."
  }, {
    "heading": "--output-format----output-format-experimentalbadge-",
    "content": "输出结果的格式。json 或 pretty（默认）"
  }, {
    "heading": "--output-format----output-format-experimentalbadge-",
    "content": "¥Format to output the results. json or pretty (default)"
  }],
  "headings": [{
    "id": "标志-flags",
    "content": "标志 /*flags*/"
  }, {
    "id": "--affected---affected",
    "content": "--affected /*--affected*/"
  }, {
    "id": "--output-format----output-format-experimentalbadge-",
    "content": "--output <format>  /*--output-format-experimentalbadge-*/"
  }]
};
import {ExperimentalBadge} from '#components/experimental-badge';
export const toc = [{
  depth: 2,
  url: "#标志-flags",
  title: _jsx(_Fragment, {
    children: "标志 "
  })
}, {
  depth: 3,
  url: "#--affected---affected",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--affected"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--output-format----output-format-experimentalbadge-",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--output <format>"
    }), " ", _jsx(ExperimentalBadge, {}), " "]
  })
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "列出你的 monorepo 中的包。"
    }), "\n", _jsx(_components.p, {
      children: "¥List packages in your monorepo."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ls"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [package(s)] [flags]"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "当范围限定为整个存储库时，输出包含软件包管理器、软件包数量以及所有软件包名称和目录。"
    }), "\n", _jsx(_components.p, {
      children: "¥When scoped to the entire repository, output includes package manager, package count, and all package names and directories."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# List all packages in the repository"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ls"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "当范围限定为一个或多个软件包时，输出包含软件包名称、目录、内部依赖和所有任务。"
    }), "\n", _jsx(_components.p, {
      children: "¥When scoped to one or more packages, output includes package name, directory, internal dependencies, and all tasks."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# List only two packages"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ls"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " web"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " @repo/ui"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [package(s)]"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "标志-flags",
      children: "标志 "
    }), "\n", _jsx(_components.p, {
      children: "¥Flags"
    }), "\n", _jsxs(_components.h3, {
      id: "--affected---affected",
      children: [_jsx(_components.code, {
        children: "--affected"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "自动过滤仅受当前分支更改影响的包。"
    }), "\n", _jsx(_components.p, {
      children: "¥Automatically filter to only packages that are affected by changes on the current branch."
    }), "\n", _jsxs(_components.p, {
      children: ["默认情况下，考虑的更改是 ", _jsx(_components.code, {
        children: "main"
      }), " 和 ", _jsx(_components.code, {
        children: "HEAD"
      }), " 之间的更改。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥By default the changes considered are those between ", _jsx(_components.code, {
        children: "main"
      }), " and ", _jsx(_components.code, {
        children: "HEAD"
      }), "."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["你可以通过设置 ", _jsx(_components.code, {
            children: "TURBO_SCM_BASE"
          }), " 将 ", _jsx(_components.code, {
            children: "main"
          }), " 覆盖为默认基础包。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥You can override ", _jsx(_components.code, {
            children: "main"
          }), " as the default base by setting ", _jsx(_components.code, {
            children: "TURBO_SCM_BASE"
          }), "."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["你可以通过设置 ", _jsx(_components.code, {
            children: "TURBO_SCM_HEAD"
          }), " 将 ", _jsx(_components.code, {
            children: "HEAD"
          }), " 覆盖为默认头包。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥You can override ", _jsx(_components.code, {
            children: "HEAD"
          }), " as the default head by setting ", _jsx(_components.code, {
            children: "TURBO_SCM_HEAD"
          }), "."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "TURBO_SCM_BASE"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "development"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ls"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --affected"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "--output-format----output-format-experimentalbadge-",
      children: [_jsx(_components.code, {
        children: "--output <format>"
      }), " ", _jsx(ExperimentalBadge, {}), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["输出结果的格式。", _jsx(_components.code, {
        children: "json"
      }), " 或 ", _jsx(_components.code, {
        children: "pretty"
      }), "（默认）"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Format to output the results. ", _jsx(_components.code, {
        children: "json"
      }), " or ", _jsx(_components.code, {
        children: "pretty"
      }), " (default)"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ls"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --output=json"
            })]
          })
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
